import {
  Component,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy,
  ViewChildren,
  QueryList,
  ElementRef,
} from '@angular/core';
import { WebService } from '../../../core/services/web-service/web.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-benner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './benner.component.html',
  styleUrl: './benner.component.scss',
})
export class BennerComponent
  implements  OnDestroy
{
  @ViewChildren('slideItem') slideItems!: QueryList<ElementRef>;
  isLoading: boolean = true;
  DataList: any[] = [];
  imageBaseUrl = environment.imageBaseUrl;
  isSliderInitialized = false;

  constructor(private WebService: WebService) {
    this.getBannerListData();
  }

  ngOnInit() {
    this.WebService.bannerDatalist$.subscribe((data) => {
      if (data?.status === 200) {
        this.DataList = data.data;
        if (!this.isSliderInitialized && this.DataList.length > 0) {
          this.initializeSlick();
        }
      } else {
        this.DataList = [];
      }
    });
  }

  // ngAfterViewInit(): void {
  //   if (!this.isSliderInitialized && this.DataList.length > 0) {
  //     this.initializeSlick();
  //   }
  // }

  // ngAfterViewChecked(): void {
  //   if (!this.isSliderInitialized && this.DataList.length > 0) {
  //     this.initializeSlick();
  //   }
  // }

  getBannerListData() {
    this.isLoading = true;
    const responseNull = true;
    this.WebService.getBannerList(1).subscribe((response: any) => {
      if (response?.status === 200) {
        // this.DataList = response.data;
        // this.initializeSlick();
        this.WebService.bannerData(response);
      } else {
        this.WebService.bannerData(response);
        this.DataList = [];
      }
      this.isLoading = false;
      this.reinitializeSlick(); // Ensure reinitialization when data changes
      const responseNull = false;
      this.WebService.bannerDataNullRespone(responseNull);
    });
  }

  initializeSlick(): void {
    setTimeout(() => {
      $('.three-slider').not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
      });
      this.isSliderInitialized = true;
    }, 0); // Add timeout to allow the DOM to render
  }

  reinitializeSlick(): void {
    if (this.isSliderInitialized) {
      $('.three-slider').slick('unslick'); // Destroy the previous slick instance
      this.isSliderInitialized = false;
    }
    this.initializeSlick();
  }

  ngOnDestroy(): void {
    if (this.isSliderInitialized) {
      $('.three-slider').slick('unslick'); // Clean up slick on component destroy
    }
  }
}
